module.exports = __webpack_public_path__ + "img/KPK Boards.43fdb3e2.png";